<script>
import { required } from 'vuelidate/lib/validators'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import TopIndicators from '@components/topindicators'

// import Indicators from './indicators'

import axios from 'axios'

export default {
	page: {
		title: 'Indicators with Intelligence',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, TopIndicators },
	data() {
		return {
			title: 'Indicators with Intelligence',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Indicators with Intelligence',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<TopIndicators :url="'/pan/xdr/indicators/info/top?limit=999'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
